import {store} from '~/store'
import {useSelector} from 'react-redux'

export const setArbitrary = (name, payload) => {
	store.dispatch({type: 'SET_VALUE', name, payload})
}

export const useArbitrary = (name, def) => {
	const data = useSelector(state => state.arbitrary[name])
	return data || def
}
